const STORAGE_KEY = 'step:paused-attempt-timers';

function storageAvailable() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function readStore() {
  if (!storageAvailable()) return {};
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(value) {
  if (!storageAvailable()) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
}

function keyFor(attemptId) {
  return String(attemptId ?? '');
}

function sameId(left, right) {
  if (left == null || right == null) return true;
  return String(left) === String(right);
}

export function savePausedAttemptTimer({ attemptId, courseId, elementId, timeRemaining }) {
  const numericTime = Number(timeRemaining);
  if (!attemptId || !Number.isFinite(numericTime)) return;

  const store = readStore();
  store[keyFor(attemptId)] = {
    attemptId,
    courseId: courseId ?? null,
    elementId: elementId ?? null,
    timeRemaining: Math.max(0, Math.floor(numericTime)),
    savedAt: Date.now(),
  };
  writeStore(store);
}

export function restorePausedAttemptTimer({ attemptId, courseId, elementId, backendTimeRemaining }) {
  if (!attemptId) return backendTimeRemaining ?? null;

  const store = readStore();
  const key = keyFor(attemptId);
  const snapshot = store[key]; // snapshot is the saved paused attempt timer for this attemptId, if it exists
  console.log('restorePausedAttemptTimer',);
  if (!snapshot) return backendTimeRemaining ?? null;

  delete store[key];
  writeStore(store);

  if (!sameId(snapshot.courseId, courseId) || !sameId(snapshot.elementId, elementId)) {
    return backendTimeRemaining ?? null;
  }

  const savedTime = Number(snapshot.timeRemaining);
  const serverTime = Number(backendTimeRemaining);
  if (!Number.isFinite(savedTime)) return backendTimeRemaining ?? null;
  if (!Number.isFinite(serverTime)) return savedTime;
  return Math.max(savedTime, serverTime);
}

export function clearPausedAttemptTimer(attemptId) {
  if (!attemptId) return;
  const store = readStore();
  delete store[keyFor(attemptId)];
  writeStore(store);
}

export const pausedAttemptTimerStorageKey = STORAGE_KEY;
